export const colorsMap = {
    light: {
        axisLine: '#E1E0DF',
        axisLabel: '#6E6E68',
        splitLine: '#E1E0DF',
    },
    dark: {
        axisLine: '#343531',
        axisLabel: '#B5B3B0',
        splitLine: '#343531',
    },
};
export const DEFAULT_SERIES_STYLES = [
    {
        color: '#0042FF',
        lineStyle: 'solid',
        width: 2,
        areaStyle: { color: '#0042FF' },
    },
    {
        color: '#B5B3B0',
        lineStyle: [4],
        width: 2,
        areaStyle: {
            color: '#6F6F69',
        },
    },
];
